import { FormattedMessage } from 'react-intl';
import LanguageCode from '@alltrails/shared/types/LanguageCode';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import useLanguageCode from 'hooks/useLanguageCode';
import * as styles from './styles/styles.module.scss';
import { getOrganizations, GiveOrganization } from './organizations';
import Organization from './Organization';
import OnePercentLogo from '../../../../assets/images/about/logos/one-percent-logo.svg';
import OnePercentLogoEn from '../../../../assets/images/about/logos/one-percent-logo-en.svg';
import GIVING_BACK_STRINGS from './givingBack.strings';

const GivingBack = (): JSX.Element => {
  const { formattedDefaultMessages } = useFormatMessage(GIVING_BACK_STRINGS);
  const languageCode = useLanguageCode();
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.heading}>
          <div className={styles.headingText}>
            <div className={styles.title}>
              <FormattedMessage
                defaultMessage="We put our money {br}<span>where the trails are</span>"
                values={{ span: (chunks: string) => <span className={styles.yellow}>{chunks}</span>, br: <br /> }}
              />
            </div>
            <div className={styles.subtitle}>
              <FormattedMessage defaultMessage="As proud 1% for the Planet partners, we contribute part of our annual revenue to organizations that protect and increase equitable access to the outdoors. Here’s where our 1% contributions go:" />
            </div>
          </div>
          <div className={styles.logoContainer}>
            <img src={languageCode === LanguageCode.English ? OnePercentLogoEn : OnePercentLogo} className={styles.onePercentLogo} loading="lazy" />
          </div>
        </div>
        <div className={styles.organizations}>
          {getOrganizations(formattedDefaultMessages).map((org: GiveOrganization) => {
            const organizationId = org.name.toLowerCase().split(' ').join('-');
            return <Organization key={organizationId} org={org} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default GivingBack;
